import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DogBreedMultiselectPickerModule } from '../../shared/components/dog-breed-multiselect-picker/dog-breed-multiselect-picker.module';
import { OwnerAdModule } from '../../shared/components/owner-ad/owner-ad.module';
import { OwnerMenuModule } from '../../shared/components/owner-menu/owner-menu.module';
import { SliderModule } from '../../shared/components/slider/slider.module';
import { EnterTheViewportNotifierDirective } from '../../shared/directives/enter-the-viewport-notifier.directive';
import { SharedModule } from '../../shared/shared.module';
import { ProviderMenuModule } from '../provider-profile/provider-menu/provider-menu.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
@NgModule({
  declarations: [HomeComponent],
  imports: [
    SharedModule,
    HomeRoutingModule,
    BrowserAnimationsModule,
    MatButton,
    OwnerAdModule,
    MatIcon,
    OwnerMenuModule,
    MatProgressSpinner,
    EnterTheViewportNotifierDirective,
    SliderModule,
    DogBreedMultiselectPickerModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    ProviderMenuModule,
  ],
})
export class HomeModule {}
